import { InjectionToken } from '@angular/core';
import { createHttpContextFromOptions } from '@quipex/core/primitives';
import type {
    BillingApiService,
    BuildingCheckoutBillingInterval,
} from '@quipex/shared/contracts';
import { firstValueFrom, map } from 'rxjs';

export type CheckoutRedirect = (checkoutUrl: string) => void;

export const CHECKOUT_REDIRECT = new InjectionToken<CheckoutRedirect>(
    'Stripe checkout redirect',
    {
        providedIn: 'root',
        factory: () => (checkoutUrl: string) => {
            window.location.assign(checkoutUrl);
        },
    }
);

export function publishBuilding(
    billingApi: BillingApiService,
    buildingId: string,
    billingInterval: BuildingCheckoutBillingInterval,
    redirectToCheckout: CheckoutRedirect
): Promise<void> {
    const context = createHttpContextFromOptions({
        // The checkout dialog owns Stripe handoff progress and failure feedback.
        suppressAutoErrorToast: true,
    });

    return firstValueFrom(
        billingApi
            .createBillingBuildingCheckoutSession(
                buildingId,
                { billingInterval },
                { context }
            )
            .pipe(
                map((response) => {
                    if (!response.checkoutUrl) {
                        throw new Error(
                            'Checkout session did not include a redirect URL'
                        );
                    }

                    redirectToCheckout(response.checkoutUrl);
                })
            )
    );
}
